import React, { useEffect, useState } from 'react'
import '../assets/css/productCateloge.css'
import ProductCard from './ProductCard'
import axios from 'axios'
import p1 from '../assets/images/products/1.jpeg'

function ProductCateloge() {
    const [products, setProducts] = useState([])
    const backendUrl = process.env.REACT_APP_BACKEND_URI

    useEffect(() => {
        axios.get(`${backendUrl}/products`)
            .then(res => { setProducts(res.data); console.log(products) })
            .catch(err => console.error(err))
    }, [backendUrl])

    return (
        <div className="product-cateloge">
            <div className="product-cateloge-header">
                <span className="product-cateloge-header-tag">OUR PRODUCTS</span>
                <h2>Our Products & Applications</h2>
            </div>

            <div className="product-cateloge-grid d-grid">
                {products
                    .filter(product => !product.is_latest_product)
                    .map(product => (
                        <ProductCard key={product._id} product={product} />
                    ))
                }
            </div>
        </div>
    )
}

export default ProductCateloge
